import { ProfileTestQuestions } from '@prisma/client';

import { QuestionType } from '../enums';

export type FormInput = QuestionType;
export type OpenQuestionType = 'number' | 'text';

export const profileTestQuestionCategories = [
  'to_start',
  'important_for_me_at_work',
  'i_expect_from_my_manager',
  'comfortable_in_a_work_environment_where',
  'about_you',
] as const;
export type ProfileTestQuestionCategory = (typeof profileTestQuestionCategories)[number];

export type ProfileQuestionnaireOption = {
  id: string;
  label: string;
  index: number;
};

export type ProfileQuestionnaireQuestion = {
  id: string;
  input: FormInput;
  openInputType?: OpenQuestionType;
  index: number;
  label: string;
  options: ProfileQuestionnaireOption[];
  category: ProfileTestQuestionCategory;
};

export type ProfileQuestionnaireStep = {
  id: string;
  label: string;
  index: number;
  questions: ProfileQuestionnaireQuestion[];
  category: ProfileTestQuestionCategory;
};

export type ProfileQuestionnaire = ProfileTestQuestions[];
